import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';
import { STORE_STATUS_ERROR, STORE_STATUS_SUCCESS, DISTANCE_GOOGLE_API, DISTANCE_GOOGLE_API_ERROR, DISTANCE_GOOGLE_API_SUCCESS, NEARBY_STORES, NEARBY_STORES_ERROR, SET_ON_PRE_30_MIN_POPUP_SCREENCHECK, NEARBY_STORES_SUCCESS, RESET_STORES, STORE_AVAILABLE_TIME_SLOTS_REQUEST, STORE_AVAILABLE_TIME_SLOTS_SUCCESS, STORE_AVAILABLE_TIME_SLOTS_FAILURE, STORE_SCHEDULE_DATA, GET_STORE_STATUS_ON_TIME_SUCCESS, GET_STORE_STATUS_ON_TIME_ERROR, STORE_STATUS, GET_STORES, SET_STORE_FAVOURITE, SET_STORE_UN_FAVOURITE, SET_GEOHASH_COUNT, SELECTED_DISPOSITION, STORE_AVAILABLE_ALL_TIME_SLOTS_REQUEST, STORE_AVAILABLE_ALL_TIME_SLOTS_SUCCESS, STORE_AVAILABLE_ALL_TIME_SLOTS_FAILURE, GET_STORE_DETAILS_FAILURE, GET_STORE_DETAILS, GET_STORE_DETAILS_SUCCESS, GET_RESTAURANT_DETAILS_FAILURE, GET_RESTAURANT_DETAILS, GET_RESTAURANT_DETAILS_SUCCESS, RESET_STORE_DETAILS, RESET_RESTAURANT_DETAILS, SET_DISPOSITION, RESET_DISPOSITION, SHOW_DISPOSITION_MODAL, SET_ADDITIONAL_ADDRESS, SET_STATE_FOR_SELECTKFC, STORE_LOCATION_SUCCESS, USER_LOCATION_DENIED, USER_LOCATION, RESET_USER_LOCATION, SET_ERROR_MESSAGE, FAVORITE_STORE_STATUS, FAVORITE_STORE_STATUS_ERROR, FAVORITE_STORE_STATUS_SUCCESS, ORDER_READY_DATETIME_UPDATE, ORDER_READY_DATETIME_UPDATED_SUCCESS, GET_STORES_DETAILS_CONTENT_FULL, GET_STORES_DETAILS_CONTENT_FULL_SUCCESS, GET_STORES_DETAILS_CONTENT_FULL_FAILURE, SET_ON_FIND_A_KFC_PAGE, SET_STORE_UN_FAVOURITE_SUCCESS, SET_STORE_UN_FAVOURITE_ERROR, SET_STORE_FAVOURITE_ERROR, SET_STORE_FAVOURITE_SUCCESS, SET_ROOT, SET_STORE_OPENTIME_CLOSEDTIME, SET_STORE_PLACE_ID, USER_LOCATION_ACCESS_STATUS, RESET_STORE_DATA, SET_ON_PRE_45_MIN_POPUP_SCREENCHECK, GET_CONTACT_US_RESTAURANT_DETAILS, GET_CONTACT_US_RESTAURANT_DETAILS_FAILURE, GET_CONTACT_US_RESTAURANT_DETAILS_SUCCESS, } from '../../constants';
import DayJsUtil from '../../utils/DayJSUtils';
const initialState = {
    allStores: [],
    allStoresWithDistance: [],
    storesWithStatus: [],
    favoriteStoresWithStatus: [],
    allStoresError: false,
    allStoresWithDistanceError: false,
    storesSatusError: false,
    storesAvilableTimeSlots: {},
    storeAvilableTimeSlotsError: false,
    storesTimeSlots: {},
    selectedStoreDetailsDL: {},
    selectedStoreDetailsDLError: false,
    selectedRestaurantDetailsDL: {},
    selectedRestaurantDetailsDLError: false,
    storeTimeSlotsError: false,
    geolocationResult: [],
    disposition: '',
    fulfillment: {},
    store: {},
    selectedDisposition: '',
    storesUpdated: false,
    isGoogleDistanceLoading: false,
    isStoreStatusLoading: false,
    isFavoriteStoreStatusLoading: false,
    isNearByStoresLoading: false,
    isStoreTimeSlotsLoading: false,
    isStoreAllTimeSlotsLoading: false,
    isStoreFavouriteLoading: false,
    isStoreUnFavouriteLoading: false,
    isStoreDetailsLoading: false,
    isRestaurantDetailsLoading: false,
    count: 0,
    currentCount: 0,
    showDispositionModal: false,
    addAddress: '',
    additionalAddress: '',
    showSelectKfc: false,
    userLocationDenied: '',
    userLocation: {},
    storeCurrentLocation: {},
    showErrorMessage: false,
    updateOrderDateTimeLoading: false,
    storeDetailsContentFull: {},
    storeDetailsContentFullError: false,
    isStoreDetailsContentLoading: false,
    onStoreFindAKfcPage: false,
    isPreStore45Popup: true,
    isPreStore30Popup: true,
    isStoreUnFavouriteSuccess: false,
    isStoreUnFavouriteError: false,
    isStoreFavouriteSuccess: false,
    isStoreFavouriteError: false,
    isRootValue: '',
    storeTime: '',
    storePlaceIdData: {},
    selectedContactUsRestaurantDetails: [],
    selectedContactUsRestaurantDetailsError: false,
    isContactUsRestaurantDetailsLoading: false,
};
const storesReducer = (state = initialState, action) => {
    const { count } = state;
    let currentCount;
    switch (action.type) {
        case NEARBY_STORES:
            return {
                ...state,
                isNearByStoresLoading: true,
                storesUpdated: false,
                currentCount: 0,
            };
        case NEARBY_STORES_SUCCESS:
            const { allStores } = state;
            let uniqueStores = allStores.concat(action.response);
            uniqueStores = uniqBy(uniqueStores, 'id');
            currentCount = getCurrentCount(state);
            return {
                ...state,
                allStores: uniqueStores,
                storesUpdated: currentCount === count,
                allStoresError: false,
                isNearByStoresLoading: false,
                currentCount,
            };
        case NEARBY_STORES_ERROR:
            currentCount = getCurrentCount(state);
            return {
                ...state,
                allStoresError: true,
                storesUpdated: currentCount === count,
                isNearByStoresLoading: false,
                currentCount,
            };
        case DISTANCE_GOOGLE_API:
            return {
                ...state,
                storesUpdated: false,
                isGoogleDistanceLoading: true,
                isStoreStatusLoading: action.setStatusFlag,
            };
        case DISTANCE_GOOGLE_API_SUCCESS:
            const { allStoresWithDistance } = state;
            let allUniqueStores = allStoresWithDistance.concat(action.response);
            allUniqueStores = uniqBy(allUniqueStores, 'id');
            const validUniqueStoresWithDistance = allUniqueStores?.length > 0;
            return {
                ...state,
                allStoresWithDistance: allUniqueStores,
                allStoresWithDistanceError: !validUniqueStoresWithDistance,
                isGoogleDistanceLoading: false,
            };
        case DISTANCE_GOOGLE_API_ERROR:
            return {
                ...state,
                allStoresWithDistanceError: true,
                isGoogleDistanceLoading: false,
                isStoreStatusLoading: false,
            };
        case STORE_STATUS:
            return {
                ...state,
                storesUpdated: false,
                isStoreStatusLoading: true,
                isGoogleDistanceLoading: action.setStatusFlag,
            };
        case FAVORITE_STORE_STATUS:
            return {
                ...state,
                isFavoriteStoreStatusLoading: true,
            };
        case STORE_STATUS_SUCCESS:
            const validStores = action?.response?.length > 0 ? validStoresWithSummary(action?.response) : action?.response || [];
            const validStoresLength = validStores?.length > 0;
            return {
                ...state,
                storesWithStatus: validStores,
                storesSatusError: !validStoresLength,
                isStoreStatusLoading: false,
            };
        case FAVORITE_STORE_STATUS_SUCCESS:
            // eslint-disable-next-line no-case-declarations
            const validFavoriteStores = action?.response?.length > 0 ? validStoresWithSummary(action?.response) : action?.response || [];
            // eslint-disable-next-line no-case-declarations
            const validFavStoresLength = validFavoriteStores?.length > 0;
            return {
                ...state,
                favoriteStoresWithStatus: validFavoriteStores,
                isFavoriteStoreStatusLoading: false,
            };
        case STORE_STATUS_ERROR:
            return {
                ...state,
                storesStatusError: true,
                isStoreStatusLoading: false,
                isGoogleDistanceLoading: false,
            };
        case FAVORITE_STORE_STATUS_ERROR:
            return {
                ...state,
                isFavoriteStoreStatusLoading: false,
            };
        case RESET_STORES:
            return {
                ...state,
                allStores: [],
                allStoresWithDistance: [],
                storesWithStatus: [],
                favoriteStoresWithStatus: [],
                allStoresError: false,
                allStoresWithDistanceError: false,
                storesSatusError: false,
                count: 0,
            };
        case STORE_AVAILABLE_TIME_SLOTS_REQUEST:
            return {
                ...state,
                isStoreTimeSlotsLoading: true,
            };
        case STORE_AVAILABLE_TIME_SLOTS_SUCCESS:
            return {
                ...state,
                storesAvilableTimeSlots: action.response,
                storeAvilableTimeSlotsError: false,
                isStoreTimeSlotsLoading: false,
            };
        case STORE_AVAILABLE_TIME_SLOTS_FAILURE:
            return {
                ...state,
                storeAvilableTimeSlotsError: true,
                isStoreTimeSlotsLoading: false,
            };
        case STORE_AVAILABLE_ALL_TIME_SLOTS_REQUEST:
            return {
                ...state,
                isStoreAllTimeSlotsLoading: true,
            };
        case STORE_AVAILABLE_ALL_TIME_SLOTS_SUCCESS:
            return {
                ...state,
                storesAvilableAllTimeSlots: action.response,
                storeAvilableAllTimeSlotsError: false,
                isStoreAllTimeSlotsLoading: false,
            };
        case STORE_AVAILABLE_ALL_TIME_SLOTS_FAILURE:
            return {
                ...state,
                storeAvilableAllTimeSlotsError: true,
                isStoreAllTimeSlotsLoading: false,
            };
        case STORE_SCHEDULE_DATA:
            const id = get(state, 'store.id');
            const storeId = get(action, 'payload[1].store.storeId');
            const storeData = storeId === id ? { ...state.store, ...action.payload[1].store, disposition: action?.payload[0]?.disposition, } : { ...action?.payload[1]?.store, service: action?.payload[0]?.disposition };
            return {
                ...state,
                disposition: action.payload[0].disposition,
                store: storeData,
                fulfillment: action.payload[2].fulfillment,
                geolocationResult: action.payload[3].geolocationResult,
            };
        case SELECTED_DISPOSITION:
            return {
                ...state,
                selectedDisposition: action.payload.selectedDisposition,
            };
        case GET_STORE_STATUS_ON_TIME_SUCCESS:
            const validStoresOnTime = action?.response?.length > 0 ? validStoresWithSummary(action?.response) : [];
            const validStoresOnTimeLength = validStoresOnTime?.length > 0;
            return {
                ...state,
                storesWithStatus: validStoresOnTime,
                storesSatusError: !validStoresOnTimeLength,
                storesTimeSlots: action.response,
                storesTimeSlotsError: false,
            };
        case GET_STORE_STATUS_ON_TIME_ERROR:
            return {
                ...state,
                storesTimeSlots: {},
                storesTimeSlotsError: true,
            };
        case GET_STORES:
            return {
                ...state,
                isStoresLoading: action.isLoading,
                isGoogleDistanceLoading: action.isLoading,
                isStoreStatusLoading: action.isLoading,
                storesUpdated: false,
            };
        case SET_GEOHASH_COUNT:
            return {
                ...state,
                count: action.count,
            };
        case SET_STORE_FAVOURITE:
            return {
                ...state,
                isStoreFavouriteLoading: true,
            };
        case SET_STORE_UN_FAVOURITE:
            return {
                ...state,
                isStoreUnFavouriteLoading: true,
            };
        case GET_STORE_DETAILS:
            return {
                ...state,
                isStoreDetailsLoading: true,
                selectedStoreDetailsDLError: false,
            };
        case GET_STORE_DETAILS_SUCCESS:
            return {
                ...state,
                selectedStoreDetailsDL: action?.payload,
                selectedStoreDetailsDLError: false,
                isStoreDetailsLoading: false,
            };
        case GET_STORE_DETAILS_FAILURE:
            return {
                ...state,
                isStoreDetailsLoading: false,
                selectedStoreDetailsDLError: true,
            };
        case GET_RESTAURANT_DETAILS:
            return {
                ...state,
                isRestaurantDetailsLoading: true,
                selectedRestaurantDetailsDLError: false,
            };
        case GET_RESTAURANT_DETAILS_SUCCESS:
            return {
                ...state,
                selectedRestaurantDetailsDL: action?.payload,
                selectedRestaurantDetailsDLError: false,
                isRestaurantDetailsLoading: false,
            };
        case GET_RESTAURANT_DETAILS_FAILURE:
            return {
                ...state,
                isRestaurantDetailsLoading: false,
                selectedRestaurantDetailsDLError: true,
            };
        case RESET_RESTAURANT_DETAILS:
            return {
                ...state,
                isRestaurantDetailsLoading: false,
                selectedRestaurantDetailsDLError: false,
                selectedRestaurantDetailsDL: {},
            };
        case GET_CONTACT_US_RESTAURANT_DETAILS:
            return {
                ...state,
                isContactUsRestaurantDetailsLoading: true,
                selectedContactUsRestaurantDetailsError: false,
            };
        case GET_CONTACT_US_RESTAURANT_DETAILS_SUCCESS:
            return {
                ...state,
                selectedContactUsRestaurantDetails: action?.payload,
                selectedContactUsRestaurantDetailsError: false,
                isContactUsRestaurantDetailsLoading: false,
            };
        case GET_CONTACT_US_RESTAURANT_DETAILS_FAILURE:
            return {
                ...state,
                isContactUsRestaurantDetailsLoading: false,
                selectedContactUsRestaurantDetailsError: true,
            };
        case RESET_STORE_DETAILS:
            return {
                ...state,
                isStoreDetailsLoading: false,
                selectedStoreDetailsDLError: false,
                selectedStoreDetailsDL: {},
            };
        case SET_DISPOSITION:
            const { disposition = '', selectedDisposition = '' } = state;
            const { service = '' } = action;
            const dispositionValue = disposition ? service : disposition;
            const selectedDispositionValue = selectedDisposition ? service : selectedDisposition;
            return {
                ...state,
                disposition: dispositionValue,
                selectedDisposition: selectedDispositionValue,
                showDispositionModal: false,
            };
        case RESET_DISPOSITION:
            return {
                ...state,
                disposition: '',
                selectedDisposition: '',
                store: {},
            };
        case SHOW_DISPOSITION_MODAL:
            const { showModal = false } = action;
            return {
                ...state,
                showDispositionModal: showModal,
            };
        case SET_ADDITIONAL_ADDRESS:
            const { value, additionalAddress } = action;
            return {
                ...state,
                addAddress: value,
                additionalAddress: additionalAddress,
            };
        case SET_STATE_FOR_SELECTKFC:
            const { boolean } = action;
            return {
                ...state,
                showSelectKfc: boolean,
            };
        case USER_LOCATION:
            return {
                ...state,
                userLocation: action.payload,
            };
        case STORE_LOCATION_SUCCESS:
            return {
                ...state,
                storeCurrentLocation: action.payload,
                maxDistance: action.payload.maxDistance,
            };
        case SET_ROOT:
            return {
                ...state,
                isRootValue: action.payload,
            };
        case USER_LOCATION_DENIED:
            return {
                ...state,
                userLocationDenied: action.payload,
            };
        case RESET_USER_LOCATION:
            return {
                ...state,
                userLocation: {},
            };
        case SET_ERROR_MESSAGE:
            const { bool } = action;
            return {
                ...state,
                showErrorMessage: bool,
            };
        case ORDER_READY_DATETIME_UPDATE:
            return {
                ...state,
                updateOrderDateTimeLoading: true,
            };
        case ORDER_READY_DATETIME_UPDATED_SUCCESS:
            return {
                ...state,
                updateOrderDateTimeLoading: false,
            };
        case GET_STORES_DETAILS_CONTENT_FULL:
            return {
                ...state,
                isStoreDetailsContentLoading: true,
                storeDetailsContentFullError: false,
            };
        case GET_STORES_DETAILS_CONTENT_FULL_SUCCESS:
            return {
                ...state,
                storeDetailsContentFull: action.response,
                storeDetailsContentFullError: false,
                isStoreDetailsContentLoading: false,
            };
        case SET_STORE_OPENTIME_CLOSEDTIME:
            return {
                ...state,
                storeTime: action.payload,
            };
        case GET_STORES_DETAILS_CONTENT_FULL_FAILURE:
            return {
                ...state,
                isStoreDetailsContentLoading: false,
                storeDetailsContentFullError: true,
            };
        case SET_ON_FIND_A_KFC_PAGE:
            const { isFromKFC } = action;
            return {
                ...state,
                onStoreFindAKfcPage: isFromKFC,
            };
        case SET_ON_PRE_45_MIN_POPUP_SCREENCHECK:
            const { isFromPre } = action;
            return {
                ...state,
                isPreStore45Popup: isFromPre,
            };
        case SET_ON_PRE_30_MIN_POPUP_SCREENCHECK:
            const { isMin } = action;
            return {
                ...state,
                isPreStore30Popup: isMin,
            };
        case SET_STORE_UN_FAVOURITE_SUCCESS:
            return {
                ...state,
                isStoreUnFavouriteLoading: false,
                isStoreUnFavouriteSuccess: true,
            };
        case SET_STORE_UN_FAVOURITE_ERROR:
            return {
                ...state,
                isStoreUnFavouriteLoading: false,
                isStoreUnFavouriteError: true,
            };
        case SET_STORE_FAVOURITE_SUCCESS:
            return {
                ...state,
                isStoreFavouriteLoading: false,
                isStoreFavouriteSuccess: true,
            };
        case SET_STORE_FAVOURITE_ERROR:
            return {
                ...state,
                isStoreFavouriteLoading: false,
                isStoreFavouriteError: true,
            };
        case SET_STORE_PLACE_ID:
            const { payload } = action;
            return {
                ...state,
                storePlaceIdData: payload,
            };
        case USER_LOCATION_ACCESS_STATUS:
            return {
                ...state,
                userLocationAccessStatus: action.payload,
            };
        case RESET_STORE_DATA:
            return {
                ...initialState,
            };
        default:
            return state;
    }
};
export const getCurrentCount = (state) => {
    let { currentCount } = state;
    currentCount += 1;
    return currentCount;
};
export const validStoresWithSummary = (stores) => {
    let validStores = [];
    validStores = stores.filter((store) => {
        // Check if store has Summary and id
        if (store?.summary && store?.summary !== {} && (store?.id || store.storeId)) {
            // Check for Valid Status
            if (store.summary?.status) {
                if (!store.summary.status?.currentStatus) {
                    return false;
                }
            }
            else {
                return false;
            }
            // valid Menu for Catalogue
            if (store.summary?.menu) {
                if (!(store.summary.menu?.catalogs && store.summary.menu?.catalogs?.length > 0)) {
                    return false;
                }
            }
            else {
                return false;
            }
            // Valid timings data
            if (store.summary?.timings) {
                if (!(store.summary.timings?.asap &&
                    store.summary.timings?.futureDates &&
                    store.summary.timings?.operatingHours &&
                    store.summary.timings?.scheduled)) {
                    return false;
                }
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
        return true;
    });
    return validStores;
};
export const getPayload = (cartData, storeStatusResponse = []) => [
    { disposition: cartData.service },
    {
        store: {
            name: [{ value: cartData?.store?.name }],
            addresses: [
                {
                    address: cartData?.deliveryAddress ?? {},
                },
            ],
            summary: storeStatusResponse[0]?.summary,
            storeId: cartData?.store?.storeId,
        },
    },
    {
        fulfillment: {
            asap: cartData?.requestedDateTime?.isForNow,
            scheduled: {
                date: DayJsUtil.formatValue(DayJsUtil.getUnix(cartData?.requestedDateTime?.futureDateTime), 'YYYY-MM-DD'),
                key: '',
                time: cartData?.requestedDateTime?.futureDateTime,
            },
        },
    },
    {
        geolocationResult: [
            {
                formatted_address: cartData?.store?.name,
                geometry: {
                    location: cartData?.deliveryAddress?.location ?? {},
                },
                place_id: '',
                deliveryAddress: cartData?.deliveryAddress ?? {},
                customProperties: [],
            },
        ],
    },
];
export const modifyStoresData = (data) => ({
    id: data?.basicDetails?.id,
    name: data?.basicDetails?.displayNames,
    timeZone: data?.basicDetails?.timeZone,
    addresses: data?.basicDetails?.localAddress,
    location: data?.basicDetails?.location,
    polygons: [],
    availableServicesPerChannel: data?.availableServicesPerChannel,
    availableTenders: data?.availableTenders,
    availableCollectionPoints: data?.availableCollectionPoints,
    amenities: data?.basicDetails?.amenities,
    additionalAttributes: data?.basicDetails?.customAttributes,
    contacts: data?.basicDetails?.contacts,
    availableTradingHours: data?.availableTradingHours,
    availableDeliveryHours: data?.availableDeliveryHours,
});
export default storesReducer;
